module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// /home/sign/front/shared/node_modules/styled-jsx/style.js
// module id = 348
// module chunks = 0